{% block prems_discount_category_detail_restriction %}
    <div>
        {# Cookie Restriction card #}
        {% block prems_discount_category_cookie_restriction %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.cookieRestriction.title')"
            :isLoading="isLoading"
        >
            <div class="prems-discount-category-detail_listing-infobox-title">
                <em>
                    {{ $tc('prems-discount-category.detail.card.cookieRestriction.helpTextTitle') }}
                </em>
            </div>
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {# Cookie name text field #}
                    {% block prems_discount_category_detail_content_cookie_restriction_name_text_field %}
                <mt-text-field
                    v-model="discountCategory.requiredCookieName"
                    :label="$tc('prems-discount-category.detail.card.cookieRestriction.field.nameTextLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.cookieRestriction.field.namePlaceholder')"
                >
                        </mt-text-field>
                {% endblock %}
                    {% block prems_discount_category_detail_content_cookie_restriction_value_text_field %}
                <mt-text-field
                    v-model="discountCategory.requiredCookieValue"
                    :label="$tc('prems-discount-category.detail.card.cookieRestriction.field.valueTextLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.cookieRestriction.field.valuePlaceholder')"
                >
                        </mt-text-field>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# URL Parameter Restriction card #}
        {% block prems_discount_category_url_parameter_restriction %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.urlParameterRestriction.title')"
            :isLoading="isLoading"
        >
            <div class="prems-discount-category-detail_listing-infobox-title">
                <em>
                    {{ $tc('prems-discount-category.detail.card.urlParameterRestriction.helpTextTitle') }}
                </em>
            </div>
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {# Cookie name text field #}
                    {% block prems_discount_category_detail_content_url_parameter_restriction_name_text_field %}
                <mt-text-field
                    v-model="discountCategory.requiredUrlParameterName"
                    :label="$tc('prems-discount-category.detail.card.urlParameterRestriction.field.nameTextLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.urlParameterRestriction.field.namePlaceholder')"
                >
                        </mt-text-field>
                {% endblock %}
                    {% block prems_discount_category_detail_content_url_parameter_restriction_value_text_field %}
                <mt-text-field
                    v-model="discountCategory.requiredUrlParameterValue"
                    :label="$tc('prems-discount-category.detail.card.urlParameterRestriction.field.valueTextLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.urlParameterRestriction.field.valuePlaceholder')"
                >
                        </mt-text-field>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# Customer Group Restriction card #}
        {% block prems_discount_category_customer_group_restriction %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.customerRestriction.title')"
            :isLoading="isLoading"
        >
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {% block prems_discount_category_detail_content_customer_group_select %}
                <prems-discount-customer-group-selector :discount-category="discountCategory"></prems-discount-customer-group-selector>
                {% endblock %}
                    {% block prems_discount_category_detail_content_customer_select %}
                <prems-discount-customer-selector :discount-category="discountCategory"></prems-discount-customer-selector>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# Sales Channel Restriction card #}
        {% block prems_discount_category_sales_channel_restriction %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.salesChannelRestriction.title')"
            :isLoading="isLoading"
        >
            <sw-container>
                {% block prems_discount_category_detail_content_sales_channel_select %}
                <prems-discount-sales-channel-selector :discount-category="discountCategory"></prems-discount-sales-channel-selector>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# Promotion Restriction card #}
        {% block prems_discount_category_promotion_restriction %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.promotionRestriction.title')"
            :isLoading="isLoading"
        >
            <div class="prems-discount-category-detail_listing-infobox-title">
                <em>
                    {{ $tc('prems-discount-category.detail.card.promotionRestriction.helpTextTitle') }}
                </em>
            </div>
            <mt-checkbox
                v-model:checked="discountCategory.blockAllOtherPromotions"
                :label="$tc('prems-discount-category.detail.card.promotionRestriction.field.blockAllText')"
            ></mt-checkbox>
            <sw-container v-if="!discountCategory.blockAllOtherPromotions">
                {% block prems_discount_category_detail_content_promotion_select %}
                <prems-discount-promotion-selector :discount-category="discountCategory"></prems-discount-promotion-selector>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}
    </div>
{% endblock %}